<div #feedback id="feedback-section" role="alert" class="alert alert-warning" style="text-align:left;">
  Attention! Once your item(s) have been added to your cart you will have 30 minutes to check out. If you do not check out within 30 minutes, the items will be removed.
</div>

<form [formGroup]="form" (ngSubmit)="addToCart()"  class="form">
  <kendo-stacklayout orientation="vertical" [align]="{ vertical: 'top' }">
    <kendo-stacklayout orientation="horizontal" [style.height.px]="300">
      <div class="box content">
        <div class="demo">
          <img kendoCardMedia src={{entity.miscellaneousItemImage}} alt=""/> 
        </div>
      </div>
      <div>
        <br />
        <kendo-card class="quantityCard">
          <kendo-card-body>
            <div style="padding: 0px 10px;">
              @if(entity)
              {
              <div class="quantityContainer">
                <h1>{{ entity.name }}</h1>
                <div>
                  <pre class="descriptionBlock">SKU: {{ entity.sku }}</pre>
                  <pre class="descriptionBlock">{{ entity.description }}</pre>
                  <div style="padding: 0px 10px; text-align: left;">

                    <div style="text-align: left; padding:5px;">
                      <label>Type</label>
                    </div>
                    <div style="text-align: left; padding-bottom:10px; width:80%">
                      <app-select-field [control]="auditTypeId"></app-select-field>
                    </div>

                    <div style="text-align: left; padding:5px;">
                      <label>Items Require Legal Hold?</label>
                    </div>
                    <div style="text-align: left; padding-bottom:10px;">
                      <input kendoCheckBox type="checkbox" name="isLegalHold" formControlName="isLegalHold" />
                    </div>

                    <div style="text-align: left; padding:5px;">
                      <label>Quantity</label>
                    </div>
                    <div style="text-align: left; padding-bottom:10px;">
                      <kendo-numerictextbox id="quantity"
                                            class="form-textbox"
                                            format="n"
                                            [min]="1"
                                            [value]="1"
                                            formControlName="quantity">

                      </kendo-numerictextbox>
                    </div>
                    <button id="addToCartBtn" class="primary" type="submit">ADD TO CART</button>
                  </div>
                  </div>
              </div>
              }
            </div>
          </kendo-card-body>
        </kendo-card>
      </div>
    </kendo-stacklayout>
  </kendo-stacklayout>
</form>
